import { checkUser } from '@actions';
import { ConnectedRouter } from 'connected-react-router';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';

import Console from '@components/Console';
import NotFoundPage from '@components/notFoundPage';
import AuthRedirect from '@shared/AuthRedirect';
import Toast from '@shared/Toast';
import urls from '@src/urls';
import BodyContainer from '@styled/Containers/BodyContainer';

import { history } from './loggedInUser';

export default function Routes() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(checkUser());
  }, []);

  return (
    <ConnectedRouter history={history}>
        <BodyContainer>
          <Toast />
          <Switch>
            <Route
              exact={true}
              path={[
                urls.root(),
                urls.authed.console(),
                urls.authed.profile(),
                urls.authed.faq(),
                urls.authed.lists(),
              ]}
            >
                <Console />
            </Route>
            {/* Fall-through */}
            <Route>
              <NotFoundPage />
            </Route>
          </Switch>
        </BodyContainer>
    </ConnectedRouter>
  );
}
